import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { getLabelFallback, getSubtotal, convertNumber } from '@utils/utils';
import { useNavigate, useLocation } from 'react-router-dom';

import * as actions from "@redux-actions/";

type Props = {
    loader?: boolean;
}


const KlarnaPayCard = ({ loader } : Props) : JSX.Element => {
    const dispatch = useDispatch();

    const config = useSelector(state => state.cart.config);
    const cart = useSelector(state => state.cart.cart);
    const address = useSelector(state => state.cart.address);

    const navigate = useNavigate();
    const { search } = useLocation();

    const [errorAuthorize, setErrorAuthorize] = useState(null);

    const klarnaCheckout = () => {
        dispatch(actions.startLoading());
        Klarna.Credit.authorize({}, function(resk) {
            const authToken = resk["authorization_token"];
            const isApproved = resk["approved"];
            const showForm = resk['show_form'];

            if(!authToken || authToken.length === 0 || !isApproved || isApproved.length === 0) {
                console.log('>>> Klarna payment handle', resk);
                dispatch(actions.endLoading());
                /* @ts-expect-error */
                window.location = decodeURIComponent(config.klarna.redirectUrl);
            } else {
                axios({
                    url: config.hostname + config.klarna.authorizePaymentUrl,
                    method: 'POST',
                    data: {
                        preapprovalToken: authToken,
                        storeId: config.storeId,
                        catalogId: config.catalogId,
                        orderId: cart.orderId,
                        shippingAddressId: !!address.billingAddressId ? address.billingAddressId : address.deliveryAddressId,
                        billingAddressId: address.deliveryAddressId
                    }
                }).then(res => {
                    console.log('>>>> Redirect to typ');
                    dispatch(actions.endLoading());
                    /* @ts-expect-error */
                    window.location = decodeURIComponent(res.data.redirecturl);
                }).catch(err => {
                    if (err[0].errorMessage) {
                        setErrorAuthorize(err[0].errorMessage);
                    } else {
                        if (err[0].errorMessageKey) {
                            setErrorAuthorize(err[0].errorMessageKey);
                        }
                    }
                    const obj = {
                        id: 'Event',
                        Events_Error: '1',
                        Error_Source: "Server",
                        Error_Code: "Checkout - Shipping",
                        Error_Details: 'Error klarna checkout',
                        Error_Message: 'Error klarna checkout'
                    }
                    dispatch(actions.endLoading());
                    window.tealium_data2track.push(obj);
                    /* @ts-expect-error */
                    window.location = decodeURIComponent(err.response.redirecturl);
                })
            }
        });
    }

    return(!!cart && parseFloat(getSubtotal(cart)) > 0 ?
        <div className="klarna-pay-card">
            <div id="klarna-payments-container" style={{maxWidth: "500px", margin: "auto"}}></div>
            {
                loader === true &&
                    <div style={{width: "100%", height:"404px", display: "flex", alignItems: "center"}}>
                        <div className="klarna-pay-card-loader">
                        </div>
                    </div>
                   
            }

            {!errorAuthorize ? 
                <button className="violet-button" onClick={klarnaCheckout}>{ getLabelFallback('PAY_CONFIRM_KLARNA_BUTTON_LABEL') }</button> :
                <div className="klarna-pay-card-error">
                    { errorAuthorize }
                </div>
            }
        </div>
    : getLabelFallback('NOT_AVAILABLE_LABEL') 
    )
};

export default KlarnaPayCard;
